import React, { useState } from "react";
import fetch from "isomorphic-unfetch";
import { loadStripe } from "@stripe/stripe-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
  "pk_live_51Hm3AYEle5f5egjw5R8esKApXYNsGHWZFPadw0zN2eqjR96t4FZ6OJ77VUumIGOTWnBq0GU7cL4GwmT7kuv2QJ9K003tHe6tGt"
);
const validator = require("email-validator");

const config = {
  stripe: {
    apiKey:
      "pk_live_51Hm3AYEle5f5egjw5R8esKApXYNsGHWZFPadw0zN2eqjR96t4FZ6OJ77VUumIGOTWnBq0GU7cL4GwmT7kuv2QJ9K003tHe6tGt",
    apiUrl:
      "https://2tjkrkn7p7.execute-api.eu-west-1.amazonaws.com/dev/checkout",
    currency: "GBP",
  },
};

const StripeCheckoutButton = () => {
  const [quantity, setQuantity] = useState(1);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [quizAnswer, setQuizAnswer] = useState("");
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [quizError, setQuizError] = useState(false);
  const [pending, setPending] = useState(false);

  // Christmas quiz question - simple but requires thought
  const quizQuestion =
    "According to the popular Christmas carol, what did my true love give to me on the fifth day of Christmas?";
  const quizOptions = [
    { value: "A", label: "A. Four calling birds" },
    { value: "B", label: "B. Five gold rings" },
    { value: "C", label: "C. Six geese a-laying" },
    { value: "D", label: "D. Five Christmas puddings" },
  ];
  const correctAnswer = "B"; // Five gold rings

  const handleClick = async (event) => {
    // Get Stripe.js instance
    let error = false;
    setPending(true);

    console.log(quantity, name, email, phone, quizAnswer);

    if (name.trim().length < 5) {
      setNameError(true);
      error = true;
    } else {
      setNameError(false);
    }
    if (phone.trim().length < 8) {
      setPhoneError(true);
      error = true;
    } else {
      setPhoneError(false);
    }
    if (!validator.validate(email.trim())) {
      setEmailError(true);
      error = true;
    } else {
      setEmailError(false);
    }
    // Validate quiz answer
    if (quizAnswer !== correctAnswer) {
      setQuizError(true);
      error = true;
    } else {
      setQuizError(false);
    }

    if (error) {
      setPending(false);
      return;
    }

    const stripe = await stripePromise;

    // Call your backend to create the Checkout Session

    const response = await fetch(config.stripe.apiUrl, {
      method: "POST",
      body: JSON.stringify({
        charge: {
          name,
          quantity,
          phone,
          email,
          domain: window.location.protocol + "//" + window.location.hostname,
          quizAnswer: quizAnswer, // Include quiz answer in submission
        },
      }),
    });

    const session = await response.json();
    console.log(session);
    if (session && session.session && session.session.id) {
      // When the customer clicks on the button, redirect them to Checkout.
      const result = await stripe.redirectToCheckout({
        sessionId: session.session.id,
      });
      setPending(false);

      if (result.error) {
        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `result.error.message`.
      }
    } else {
      setPending(false);
    }
  };

  return (
    <div>
      <p className="text-black text-center text-2xl lg:text-4xl font-bold mt-6">
        Enter our Christmas Competition
      </p>
      <p className="text-black text-center text-xl lg:text-3xl font-thin mt-6">
        Answer the question below correctly to enter for £1 per entry.
        <br />
        Pay by Debit or Credit Card, Apple Pay or Google Checkout.
      </p>
      <form className="w-full max-w-xl mx-auto pt-12 pb-12">
        {/* Quiz Question Section */}
        <div className="flex flex-wrap mb-8 bg-green-50 border-2 border-green-200 rounded-lg p-6">
          <div className="w-full mb-4">
            <label
              className="block text-gray-800 font-bold mb-4 text-lg"
              htmlFor="quiz"
            >
              🎄 Competition Question:
            </label>
            <p className="text-gray-700 mb-4 text-base leading-relaxed">
              {quizQuestion}
            </p>
            <div className="space-y-3">
              {quizOptions.map((option) => (
                <label
                  key={option.value}
                  className="flex items-center space-x-3 cursor-pointer p-3 rounded hover:bg-green-100 transition"
                >
                  <input
                    type="radio"
                    name="quiz"
                    value={option.value}
                    checked={quizAnswer === option.value}
                    onChange={(e) => setQuizAnswer(e.target.value)}
                    className="w-4 h-4 text-green-600"
                  />
                  <span className="text-gray-700">{option.label}</span>
                </label>
              ))}
            </div>
            {quizError && (
              <p className="text-red-500 italic mt-3">
                Sorry, that's not correct. Please try again! (Hint: It's a very
                famous line from the song)
              </p>
            )}
          </div>
        </div>

        {/* Existing form fields */}
        <div className="flex flex-wrap mb-6">
          <div className="w-full px-3 mb-6 md:mb-0">
            <label
              className="block uppercase tracking-wide text-gray-700 font-bold mb-2"
              htmlFor="name"
            >
              Name
            </label>
            <input
              maxLength={50}
              onChange={(e) => {
                setName(e.target.value);
              }}
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-400"
              id="name"
              type="text"
              placeholder="e.g. Jane Smith"
            />
            {nameError && (
              <p className="text-red-500 italic">Please enter your name.</p>
            )}
          </div>
          <div className="w-full px-3 mb-6 md:mb-0">
            <label
              className="block uppercase tracking-wide text-gray-700  font-bold mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              maxLength={100}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-400"
              id="email"
              type="email"
              placeholder="e.g. jane@smith.com"
            />
            {emailError && (
              <p className="text-red-500 italic">
                Please enter a valid email address.
              </p>
            )}{" "}
          </div>
          <div className="w-full px-3 mb-6 md:mb-0">
            <label
              className="block uppercase tracking-wide text-gray-700 font-bold mb-2"
              htmlFor="phone"
            >
              Phone
            </label>
            <input
              max={20}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-400"
              id="phone"
              type="text"
              placeholder="e.g. 0700 123 4567"
            />
            {phoneError && (
              <p className="text-red-500 italic">
                Please enter a phone number.
              </p>
            )}{" "}
          </div>
        </div>
        <div className="flex items-end justify-between mb-2">
          <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
              className="block uppercase tracking-wide text-gray-700 font-bold mb-2"
              htmlFor="grid-state"
            >
              Number of entries
            </label>
            <div className="relative">
              <select
                onChange={(e) => {
                  setQuantity(e.target.value);
                }}
                className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-400"
                id="quantity"
              >
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>50</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <button
              disabled={pending}
              onClick={handleClick}
              className="w-full shadow bg-blue-600 hover:bg-blue-800 focus:shadow-outline focus:outline-none text-white font-bold py-3 px-4 rounded"
              type="button"
            >
              Enter Competition{" "}
              {pending && <FontAwesomeIcon icon={faSpinner} spin />}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default StripeCheckoutButton;
